import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetConversionStateRequest = App.Http.Requests.ConversionState.GetConversionStateRequest;
import GetConversionStateResponse = App.Http.Responses.ConversionState.GetConversionStateResponse;
import GetConversionStatesRequest = App.Http.Requests.ConversionState.GetConversionStatesRequest;
import GetConversionStatesResponse = App.Http.Responses.ConversionState.GetConversionStatesResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

class ConversionStateApi extends TenantBaseApi {
    async index(request: GetConversionStatesRequest): Promise<GetConversionStatesResponse> {
        return await this.get<GetConversionStatesResponse, GetConversionStatesRequest>("/conversion-states", {
            params: request,
        });
    }

    async show(conversionStateId: string, request?: GetConversionStateRequest): Promise<GetConversionStateResponse> {
        return await this.get<GetConversionStateResponse, GetConversionStateRequest>(
            `/conversion-states/${conversionStateId}`,
            {
                params: request,
            }
        );
    }

    async export(request?: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>(`/conversion-states/export`, request);
    }
}

export const conversionStateApi = new ConversionStateApi();
